<template functional>
  <header class="entry-header itmdtlhd">
    <div class="con">
      <p class="nmg tac">
        <span class="lbl" :class="props.detail.gender_class">{{props.detail.gender_name}}</span>
      </p>
      <dl>
        <dt>
           <h1 class="itmdtlnm"><router-link v-if="props.detail" :to="'/brand/' + props.detail.brand_code"><span class="itmdtlbd" >{{props.detail.brand_name_full}}</span></router-link>{{props.detail.name}}</h1>
        </dt>
        <dd class="itmdtlprc">
           <span class="prp-price" v-if="props.detail.regular_price">定価：¥{{ props.detail.regular_price | addComma}}</span>
           <span class="price" v-if="props.detail.min_price">¥{{ props.detail.min_price | addComma}}</span>
         </dd>
        <dd class="nmg fsS tac">メーカー品番：{{props.detail.maker_item_code}}</dd>
     </dl>
    </div>
  </header>
</template>

<script>
export default {
  props: ['detail'],
}
</script>

<style scoped>
.itmdtlhd{z-index: 1000; margin-top: -70px; position: relative;
  background: -moz-linear-gradient(top,rgba(240,240,240,0.3),rgba(255,255,255,0.9)); 	background: -o-linear-gradient(rgba(255,255,255,0.3),rgba(255,255,255,0.9));
  background: -webkit-gradient(linear,left top,left bottom,from(rgba(255,255,255,0.3)),to(rgba(255,255,255,0.9)));
  background: linear-gradient(top,rgba(240,240,240,0.3),rgba(255,255,255,0.9));
  padding: 16px 0;
  box-shadow: 0px 2px 6px -7px rgba(204,204,204,0.6); -webkit-box-shadow: 0px 2px 24px 0 rgba(0,0,0,0.2);-moz-box-shadow: 0px 2px 6px -7px rgba(204,204,204,0.6);
}
.itmfav{display: block; position: absolute; top: 0; left: 0;}
.ic-fav_mini {width: 16px; height: 16px; display: inline; background-image:url('http://cdn.tokyowave.net/img/ic-fav_on.png'); line-height: 14px; background-size: 16px 16px;}

.itminginr .ic-fav_off {display: none;}

.inrsdw{box-shadow:0px 0px 14px 0px #CCC inset;
-moz-box-shadow:0px 0px 14px 0px #CCC inset;
-webkit-box-shadow:0px 0px 14px 0px #CCC inset;}

.itmdtlbd {
    display: block;
    font-size: .8em;
    padding: 12px 0;
    font-weight: normal;
}

.itmdtlnm {
    text-align: center;
    font-size: 1.2em;
    padding: 0;
    margin: 0;
}

.itmdtlprc {
    font-size: 2.0em;
    text-align: center;
    margin: 0;
}

.prp-price {
    font-size: .6em;
    display: block;
    color: #CCC;
}

.price {
    font-weight: bold;
    color: #FF3300;
}

</style>
